import { isArray } from 'util';
import { mapCollection, sortByString } from '../../utils/collection.utils';
import { Client } from '../client';

export class ClientBuilder {
  static fromJson(json): Client {
    return (json)
      ? new Client(
        json.hash,
        json.code,
        json.name,
        json.businessName
      )
      : null;
  }

  static fromList(list) {
    return isArray(list) ?
      sortByString('name', mapCollection(ClientBuilder.fromJson, list)) : [];
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/builders/client.builder.ts